<template>
  <div
    class="squircle-md border-primary flex justify-end overflow-hidden rounded-md border"
  >
    <button
      class="bg-primary text-contrast-primary flex items-center justify-center disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500"
      :class="{
        'size-6': size === 'small' || size === 'medium',
        'size-4': size === 'extra-small',
        'size-8': size === 'large',
        'size-10': size === 'extra-large'
      }"
      :disabled="localQuantity === 0 || disabled"
      @click="localQuantity = localQuantity - 1"
    >
      <FontAwesomeIcon :icon="['fal', 'minus']" />
    </button>
    <input
      v-model="localQuantity"
      class="rounded bg-white px-1 py-0.5 text-center"
      :class="{
        'h-6 w-12 text-xs': size === 'small',
        'text-xxs h-4 w-10': size === 'extra-small',
        'h-6 w-14 text-sm': size === 'medium',
        'h-8 w-16 text-base': size === 'large',
        'h-10 w-18 text-lg': size === 'extra-large'
      }"
      type="number"
      min="0"
      :max="maxQuantity"
      :disabled="disabled"
    />
    <button
      class="bg-primary text-contrast-primary flex items-center justify-center disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500"
      :class="{
        'size-6': size === 'small' || size === 'medium',
        'size-4': size === 'extra-small',
        'size-8': size === 'large',
        'size-10': size === 'extra-large'
      }"
      :disabled="localQuantity === maxQuantity || disableAddButton || disabled"
      @click="localQuantity = localQuantity + 1"
    >
      <FontAwesomeIcon :icon="['fal', 'plus']" />
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  name: 'QuantityInput',
  components: { FontAwesomeIcon },
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    maxQuantity: {
      type: Number,
      default: 9999
    },
    disableAddButton: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    localQuantity: {
      get() {
        return this.modelValue
      },
      set(value) {
        if (value > this.maxQuantity) {
          this.$emit('update:modelValue', this.maxQuantity)
        } else if (value < 0) {
          this.$emit('update:modelValue', 0)
        } else {
          this.$emit('update:modelValue', value)
        }
      }
    }
  }
})
</script>
